import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';

type HeadingProps = {
  level: 1 | 2 | 3 | 4 | 5 | 6; // The HTML heading level (h1 - h6).
  className?: string;
  children: ReactNode;
};

export default function Heading({ level, className, children }: HeadingProps): ReactElement {
  // eslint-disable-next-line default-case
  switch (level) {
    case 1:
      return <h1 className={clsx('main-layout-title', className)}>{children}</h1>;
    case 2:
      return <h2 className={clsx('h4 mb-4', className)}>{children}</h2>;
    case 3:
      return <h3 className={clsx('h5 mb-0', className)}>{children}</h3>;
    case 4:
      return <h4 className={clsx('', className)}>{children}</h4>;
    case 5:
      return <h5 className={clsx('', className)}>{children}</h5>;
    case 6:
      return <h6 className={clsx('', className)}>{children}</h6>;
  }
}
